import { useState } from 'react'
import { useSelector } from 'react-redux'

// antd
import { Image, Row, Space, Spin, Typography, theme } from 'antd'

// slices
import {
    profileState,
} from '../profile.slice'

// sections
import NoIndividualContent from '../tabSection/noIndividualContent'

// assets
import {
    NoProjectsIcon,
    NoProjectsImageIcon,
} from '../../../assets/icons'

// styles
import tabStyles from '../profileTabContent.module.css'

import MultiProjectMediaModal from '../modals/multiProjectMediaModal'

function ProjectsTabContent() {
    const { Title, Text } = Typography

    const { useToken } = theme
    const { token } = useToken()

    // SELECTORS
    const {
        profileData: {
            data: { projects },
        },
        status,
    } = useSelector(profileState)

    const [viewMediaProject, setViewMediaProject] = useState({
        open: false,
        project: {},
    })

    return (
        <>
            <div className={tabStyles.panel}>
                <Row align="middle" justify={'space-between'}>
                    <Title level={4} className={tabStyles.panelTitle}>
                        Projects
                    </Title>
                    {/* {userProfile?.role?.roleName !== SUPER_ADMIN && (
                        <Button
                            props={{
                                text: 'Add Project',
                                onClick: () => {
                                    dispatch(
                                        switchProfileModal({
                                            name: 'projects',
                                            open: true,
                                        })
                                    )
                                },
                            }}
                        />
                    )} */}
                </Row>
                <Spin spinning={status === 'loading' ? true : false}>
                    {status === 'loaded' && projects?.length > 0 ? (
                        <div className={tabStyles.mediaGrid}>
                            {projects.map((projectData) => (
                                <div
                                    className={tabStyles.mediaCard}
                                    key={
                                        projectData?._id ||
                                        projectData?.projectName
                                    }
                                >
                                    {projectData?.media?.length > 0 ? (
                                        <Image
                                            src={projectData?.media[0]}
                                            className={`${tabStyles.mediaThumb} ${tabStyles.mediaThumbContain}`}
                                            preview={false}
                                            onClick={() => {
                                                setViewMediaProject({
                                                    open: true,
                                                    project: projectData,
                                                })
                                            }}
                                        />
                                    ) : (
                                        <div
                                            className={tabStyles.mediaThumb}
                                            style={{
                                                backgroundColor:
                                                    token.colorPalette.textColor
                                                        .tertiary,
                                                opacity: 0.4,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: '35px',
                                                    height: '35px',
                                                }}
                                            >
                                                <NoProjectsImageIcon />
                                            </div>
                                        </div>
                                    )}
                                    <div className={tabStyles.mediaBody}>
                                        <Row justify={'space-between'}>
                                            <Space>
                                                {projectData?.projectName && (
                                                    <Title
                                                        className={`${tabStyles.mediaTitle} titleSub`}
                                                    >
                                                        {
                                                            projectData?.projectName
                                                        }
                                                    </Title>
                                                )}
                                                <Text className="titleLight">
                                                    {!projectData?.isCompleted &&
                                                        `(Draft)`}
                                                </Text>
                                            </Space>
                                            {/* {userProfile?.role?.roleName !==
                                                SUPER_ADMIN && (
                                                <div
                                                    className={tabStyles.editBtn}
                                                    onClick={() => {
                                                        dispatch(
                                                            setDeleteModalTitle(
                                                                'project'
                                                            )
                                                        )
                                                        dispatch(
                                                            switchProfileModal({
                                                                name: 'projects',
                                                                open: true,
                                                                mode: 'edit',
                                                            })
                                                        )
                                                        dispatch(
                                                            updatedDataProfile({
                                                                editData: {
                                                                    step: 'projects',
                                                                    stepField:
                                                                        '_id',
                                                                    stepFieldValue:
                                                                        projectData?._id,
                                                                },
                                                                _id: userProfile?._id,
                                                            })
                                                        )
                                                    }}
                                                >
                                                    <EditIcon />
                                                </div>
                                            )} */}
                                        </Row>
                                        <Space>
                                            {projectData?.start !== null && (
                                                <Text
                                                    style={{
                                                        fontSize:
                                                            token.fontSizeLG,
                                                    }}
                                                    className={'titleLight'}
                                                >
                                                    {new Date(
                                                        projectData?.start
                                                    )?.toLocaleString(
                                                        'default',
                                                        {
                                                            year: 'numeric',
                                                            month: 'long',
                                                        }
                                                    )}
                                                </Text>
                                            )}
                                            {projectData?.start !== null &&
                                                (projectData?.currentWorking ||
                                                    projectData?.end !==
                                                        null) &&
                                                '-'}
                                            {(projectData?.currentWorking ||
                                                projectData?.end !== null) && (
                                                <Text
                                                    style={{
                                                        fontSize:
                                                            token.fontSizeLG,
                                                    }}
                                                    className={'titleLight'}
                                                >
                                                    {projectData?.currentWorking
                                                        ? 'Present'
                                                        : new Date(
                                                              projectData?.end
                                                          )?.toLocaleString(
                                                              'default',
                                                              {
                                                                  month: 'long',
                                                                  year: 'numeric',
                                                              }
                                                          )}
                                                </Text>
                                            )}
                                        </Space>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : status === 'loaded' ? (
                        <NoIndividualContent
                            content={{
                                key: 'projects',
                                title: 'Projects',
                                icon: <NoProjectsIcon />,
                            }}
                        />
                    ) : (
                        status === 'loading' && <Spin />
                    )}
                </Spin>
            </div>

            <MultiProjectMediaModal
                projectData={viewMediaProject?.project}
                open={viewMediaProject?.open}
                onClose={() => {
                    setViewMediaProject({
                        open: false,
                        project: {},
                    })
                }}
            />
        </>
    )
}

export default ProjectsTabContent
